import { render, staticRenderFns } from "./PopupLink.vue?vue&type=template&id=84866b98&"
import script from "./PopupLink.vue?vue&type=script&lang=js&"
export * from "./PopupLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports